import { render } from "./GraphicPizza.vue?vue&type=template&id=792f798a"
const script = {}

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__